import {ITheme} from 'contexts/ThemeContext';
import {Platform} from 'react-native';
import {
  CreateResponsiveStyle,
  DEVICE_SIZES,
  minSize,
} from 'rn-responsive-styles';

export default (props: ITheme) =>
  CreateResponsiveStyle(
    {
      container: {flex: 1},

      flatList: {
        flex: 1,
        backgroundColor: props.colors.dirtyWhite,
      },
    },
    {
      [minSize(DEVICE_SIZES.SMALL_DEVICE)]: {},
      [minSize(DEVICE_SIZES.MEDIUM_DEVICE)]: {},
    },
  )();
